import { render, staticRenderFns } from "./ActivityLargeTextContainer.vue?vue&type=template&id=32a5cc2e&scoped=true"
import script from "./ActivityLargeTextContainer.vue?vue&type=script&lang=ts"
export * from "./ActivityLargeTextContainer.vue?vue&type=script&lang=ts"
import style0 from "./ActivityLargeTextContainer.vue?vue&type=style&index=0&id=32a5cc2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5cc2e",
  null
  
)

/* custom blocks */
import block0 from "./ActivityLargeTextContainer.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports